import React from "react";
import { ISampleFileDownload } from "./SampleFileDownloadComponent.interface";

import "./SampleFileDownloadComponent.scss";

const SampleFileDownloadComponent: React.FunctionComponent<
  ISampleFileDownload
> = (props: ISampleFileDownload) => {
  const { assetDownloadFileName, downloadText, maxLimitText } = props;
  return (
    <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-center csv-helper-text-container">
      <span style={{ color: "black" }}>
        <small>{maxLimitText}</small>
      </span>
      <a
        href={require(`../../../../../../assets/static/${assetDownloadFileName}`)}
        target="_blank"
      >
        <small>{downloadText}</small>
      </a>
    </div>
  );
};

SampleFileDownloadComponent.defaultProps = {
  downloadText: "Download Sample Files",
  maxLimitText: "max 2000 lines",
  assetDownloadFileName: "product_batch_csv_samples.zip",
};

export default SampleFileDownloadComponent;
